import {createDataStore} from './createDataStore';

// Caches /data/machineLearningData.json for the ML basics/concepts pages.
// See createDataStore for the fetch-once / persist-to-localStorage behaviour.
// Bump the version below whenever machineLearningData.json's content changes,
// to invalidate copies already cached in returning visitors' browsers.
export const useMlDataStore = createDataStore(
    '/data/machineLearningData.json',
    'ml-data-store',
    ['slugs', 'nextPage', 'relatedPages', 'suggestedCourses'],
    7
);
